import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';


import css from './OrderBreakdown.module.css';

const LineItemCouponDiscountMaybe = props => {
  const { lineItems, intl } = props;

  const discount = lineItems.find(item => item.code === 'line-item/coupon-discount');
  const couponCode = lineItems.find(item => item.code === 'line-item/coupon-discount');

  return discount ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage 
          id="OrderBreakdown.couponDiscount" 
          values={{ code: couponCode?.code || '' }}
        />
      </span>
      <span className={css.itemValue + ' ' + css.discount}>
        {formatMoney(intl, discount.lineTotal)}
      </span>
    </div>
  ) : null;
};

export default LineItemCouponDiscountMaybe;